export default function ($scope, $rootScope, timetableService, plannerFactory, recentSearchesFactory, alertsService, $uibModal, $filter, $timeout, $q, timetableConfig) {

    var showFirstRunModal = !timetableConfig.GODMODE,
        root = document.querySelector('[ng-controller="UscTimetableController"]'),
        overlayInterval = root.dataset.overlayInterval || 28,
        now = new Date();

    // punting this into rootscope rather than creating another service - constant value, so happy to cause a little pollution...
    $rootScope.allClassesClosedMessage = root.dataset.allClosedMessage;

    // When the term changes, update the UI via init(), which essentially resets the view
    timetableService.subscribe($scope, 'selectedTermChanged', function (e, arg) {
        init(arg);
    });

    // Raised when all courses for the selected teaching period are available
    timetableService.subscribe($scope, 'coursesChanged', function (e, arg) {
        $scope.courses = arg.data;
        $scope.loadingCourses = false;
    });

    timetableService.subscribe($scope, 'resultsChanged', function (e, arg) {
        $scope.results = arg;
        $scope.noResults = $scope.results.length === 0;
        getClasses();
    });

    // declare a bunch of scoped variables
    // arrays
    $scope.courses = [];
    $scope.results = [];
    $scope.alerts = alertsService.get();
    $scope.locationFilters = [];
    $scope.days = timetableConfig.DAYS;
    //bools
    $scope.showFilters = false;
    $scope.showError = false;
    $scope.DBErrorMsg = false;
    $scope.noActiveFilters = true;

    //numeric
    $scope.perPage = 3;
    $scope.currentPage = 1;

    // should we show the first-run modal -> godmode will supress the modal, regardless of elapsed days since last displayed
    if (!timetableConfig.GODMODE && timetableConfig.HAS_LOCALSTORAGE) {
        // check first run modal date
        if (localStorage[timetableConfig.LOCAL_STORE_KEY + 'acceptedConditions']) {
            var lastModalDate = new Date(localStorage[timetableConfig.LOCAL_STORE_KEY + 'acceptedConditions']);
            if (Object.prototype.toString.call(lastModalDate) === '[object Date]') {
                var then = lastModalDate.getTime(),
                    diff = (now.getTime() - then) / 864e5; // millseconds -> seconds -> minutes -> hours -> days

                showFirstRunModal = diff > overlayInterval;
            }
        }
    }

    $q.all([timetableService.getTerms(), timetableService.getCampus()])
        .then(function (resp) {

            if (resp[0]) {

                if (resp[0].status === 'Error' || resp[0].data.length === 0) {
                    $scope.DBErrorMsg = true;
                } else {
                    $scope.terms = $filter('orderBy')(resp[0].data, 'fullDescription');

                    if (!timetableConfig.GODMODE) {
                        $scope.terms = $scope.terms.filter(term => !term.godsOnly);
                    }
                }
            }
            if (resp[1]) {
                if (resp[1].status === 'Error' || resp[1].data.length === 0) {
                    $scope.DBErrorMsg = true;
                } else {
                    var tempLocations = [];
                    for (var camp = 0; camp < resp[1].data.length; camp++) {
                        tempLocations.push(resp[1].data[camp]);
                    }

                    $scope.locationFilters = tempLocations.sort(function (a, b) {
                        if (a < b) {
                            return -1;
                        }
                        if (a > b) {
                            return 1;
                        }
                        return 0;
                    });
                    $scope.locationFilters.unshift('Show all');
                }
            }

            $scope.loadingCourses = false;

            timetableService.checkParams($scope.terms.map(function (v) {
                return v.id;
            }));
        });

    //////////////////////////////////////////////////////
    // SCOPED FUNCTIONS
    /////////////////////////////////////////////////////

    //reseting filters
    $scope.resetFilters = function () {
        resetFilters(false);
    };

    $scope.refresh = function () {
        init();
    };

    /**
     * Filter the results set in response to a UI change
     * If no results exist, and the location filter triggers this function, force a search for all courses
     * @param {} key 
     * @returns {} 
     */
    $scope.filterResults = function (key) {
        $scope.loadingCourses = true;
        if ($scope.results.length) {
            if (key === 'time' && $scope.activeFilters.time.hour !== null) {
                $scope.badgeHour = $scope.timeFilters.hour.where(function (h) {
                    return h.value === $scope.activeFilters.time.hour;
                })[0].key;
            }

            $scope.results = $filter(key)($scope.results, key, $scope.activeFilters);
            $scope.currentPage = 1;

            countVisibleResults(); 
            countTotalPages();
            showHideActiveFilters();
        } else if (key === 'location') {
            $scope.submitSearch(null, null, true);
        }
        $scope.loadingCourses = false;
    };

    $scope.updateFilter = function (key, index, weekend) {
        if (key === 'day') {
            $scope.activeFilters.day[index] = weekend !== true;
        }
        if (key === 'program') {
            $scope.activeFilters.program = $scope.programFilters[0];
        }
        if (key === 'location') {
            $scope.activeFilters.location = $scope.locationFilters[0];
        }
        if (key === 'type') {
            $scope.activeFilters.type = $scope.typeFilters[0];
        }

        if (key === 'time') {
            $scope.activeFilters.time = {
                type: $scope.timeFilters.type[0],
                hour: null
            };
        }

        $scope.selectedfilters--;
        $scope.results = $filter(key)($scope.results, key, $scope.activeFilters);
        $scope.currentPage = 1;

        countVisibleResults();
        countTotalPages();
        showHideActiveFilters();
    };

    $scope.paging = function (i) {
        $scope.currentPage = $scope.currentPage + i;
    };

    /**
     * Set the selected term in the factory, triggering a request for all courses for the term
     * @returns {} 
     */
    $scope.setTerm = function () {
        $scope.loadingCourses = true;
        $scope.showFilters = false;
        timetableService.setSelectedTerm($scope.selectedTerm);
    };

    /**
     * Find the course detail when a selection is made in the search typeahead
     * @param {} $item 
     * @returns {} 
     */
    var prevSearchTerm = '', searching = false;

    $scope.submitSearchOnBlur = function () {
        searching = false;
        $timeout(function () {
            if (!searching) {
                $scope.submitSearch();
            }
        }, 100);
    }

    //submit button - find all courses matching search params
    $scope.submitSearch = function (typeaheadSelect, item, force) {

        searching = true;

        $scope.searchTerm = item ? item.fullDescription : $scope.searchTerm;

        if ($scope.searchTerm !== prevSearchTerm || force) {
            $scope.results = [];
            for (var i = 0, l = $scope.courses.length; i < l; i++) {
                var c = $scope.courses[i];

                if (c.fullDescription.toLowerCase().indexOf($scope.searchTerm.toLowerCase()) > -1) {
                    c.hasVisibleChildren = true;
                    c.hiddenByProgramFilter = false;

                    $scope.results.push(c);
                }
            }
            $scope.noResults = $scope.results.length === 0;

            if ($scope.searchTerm.length) {
                recentSearchesFactory.add({
                    courseCode: typeaheadSelect ? item.courseCode : $scope.searchTerm,
                    description: typeaheadSelect ? item.description : '',
                    termId: $scope.selectedTerm.id
                });
            }

            prevSearchTerm = $scope.searchTerm;

            getClasses();
        }
    }

    //////////////////////////////////////////////////////
    // PRIVATE FUNCTIONS
    /////////////////////////////////////////////////////

    /**
     * For the current set of search results, request the classes
     * @returns {} 
     */
    function getClasses() {
        $scope.loadingCourses = true;
        var ids = $scope.results.map(function (v) {
            return v.courseId;
        });

        timetableService.getClassBySearchTerm(ids)
            .then(function (resp) {
                mapClassesToCourses(resp.data);
            });
    }

    /**
     * Relate classes object to the relevant course object in the search results
     * Also store a location string on the search result to ease filtering
     * @param {} classes 
     * @returns {} 
     */
    function mapClassesToCourses(classes) {
        $scope.results.forEach(function (result) {
            var c = classes.filter(function (vv) {
                return vv.key === result.courseId;
            })[0];

            if (c) {
                var offeredLocations = c.value.map(function (v) {
                    return v.location;
                }).filter(function (value, index, self) {
                    return self.indexOf(value) === index;
                }).join('|');

                result.classes = c.value;
                result.locations = offeredLocations;
            }
        });

        // need to trigger the location filter, as a location may exist prior to the results
        filterNewResults();
        $scope.loadingCourses = false;
    }


    // Generate the hour values for the time filer
    function populateTimeFilter() {
        var arr = [], seed = 7, i = 0;
        for (; i < 15; i++) {

            var time = seed <= 12 ? seed : seed - 12;

            arr.push({
                'key': time + (seed < 12 ? 'am' : seed === 12 ? 'nn' : 'pm'),
                'value': seed + ':00'
            });

            seed = seed + 1;
        }
        return arr;
    }

    function showHideActiveFilters() {
        $timeout(function () {
            $scope.noActiveFilters = document.getElementById('filteringBy').childElementCount === 0;
        }, 10);
    }

    /**
     * 
     * @returns {} 
     */
    function countVisibleResults() {
        $scope.visibleResultsCount = $scope.results.filter(function (el) {
            var allHidden = true;
            el.allClassesClosed = el.classes.filter(function (v) {
                allHidden = v.hiddenByFilter ? allHidden : false;
                return v.enrolmentStatus !== 'O' || (v.enrolmentStatus === 'O' && v.location !== $scope.activeFilters.location && $scope.activeFilters.location !== 'Show all');
            }).length === el.classes.length;

            el.allClassesHidden = allHidden;
            return el.hiddenByProgramFilter === false && el.hiddenByLocationFilter === false && allHidden === false;
        }).length;
    }

    function countTotalPages() {
        $scope.totalPages = Math.ceil($scope.visibleResultsCount / $scope.perPage);
    }

    //review the current set filters for new results
    function filterNewResults() {

        $scope.loadingCourses = true;

        var filters = ['day', 'location', 'time', 'program'];
        for (var i = 0; i < filters.length; i++) {
            $scope.results = $filter(filters[i])($scope.results, filters[i], $scope.activeFilters);
        }
        $filter('pattern')($scope.results);

        countVisibleResults();
        countTotalPages();
        $scope.loadingCourses = false;
    }

    function resetFilters(clearSearch) {
        // reset filter values to sensible defaults
        $scope.programFilters = ['Show all', 'Undergraduate', 'Postgraduate', 'Enabling'];
        $scope.typeFilters = ['Show all', 'On-campus only', 'Online only'];
        $scope.timeFilters = {
            type: ['Show all', 'Starting after', 'Finishing before'],
            hour: populateTimeFilter()
        };

        $scope.activeFilters = {
            program: $scope.programFilters[0],
            type: $scope.typeFilters[0],
            day: [false, true, true, true, true, true, true],
            time: {
                type: $scope.timeFilters.type[0],
                hour: null
            },
            location: $scope.locationFilters[0]
        };

        if (clearSearch === undefined) {
            //reset course search term 
            $scope.searchTerm = '';
            $scope.totalPages = 0;
            $scope.errorMsg = '';
            //Reseting course details search 
        } else {
            filterNewResults();
        }
    }

    if (showFirstRunModal && !timetableConfig.GODMODE) {
        var firstRunModalInstance = $uibModal.open({
            templateUrl: 'firstRunModal.html',
            controller: 'FirstRunModalCtrl',
            backdrop: 'static'
        });

        firstRunModalInstance.result.then(function (resp) {
            if (resp) {
                resetFilters();
                if (timetableConfig.HAS_LOCALSTORAGE) {
                    localStorage[timetableConfig.LOCAL_STORE_KEY + 'acceptedConditions'] = new Date();
                }
            }
        });
    } else {
        resetFilters();
    }

    /**
     * Reset button or semester change calls init, clears all semester-specific variables
     * @param {} arg 
     * @returns {} 
     */
    function init(arg) {
        $scope.selectedTerm = arg || undefined;
        $scope.loadingCourses = true;
        $scope.showFilters = true;
        $scope.results = [];
        $scope.visibleResultsCount = 0;
        $rootScope.showAll = arg ? timetableService.getSelectedTerm().showAllFrom < now.getTime() || timetableConfig.GODMODE : false;

        if (timetableConfig.HAS_LOCALSTORAGE) {
            plannerFactory.clearPlannerUi();
            plannerFactory.getFromLocalStorage();
        }

        resetFilters();

        // this is a bit lazy, but fixes the infinite loading when reverting back to a previously selected teaching period
        $scope.loadingCourses = false;
    }
};